<template>
   <v-layout align-center justify-center class="upload_bg">
        <v-toolbar fixed flat class="transparent">
            <v-spacer></v-spacer>
            <v-toolbar-items>       
                <v-btn dark flat @click="closeDialog">Close</v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-alert v-if="error" :value="true" color="error" icon="error" outline class="rounded-4">
            Error encountered. Please contact support. Error details: {{errorMessage}}
        </v-alert>
        
        <v-flex xs12 sm7> 
            <div class="text-xs-center">
                <p class="subheading white--text">Use a short, descriptive file name.</p> 
                <vue-dropzone ref="myVueDropzone" 
                    v-if="userId" 
                    class="upload_drop"
                    id="dropzone" 
                    v-show="showUpload"
                    :options="dropzoneOptions"
                    v-on:vdropzone-success="uploadSuccess"
                    v-on:vdropzone-file-added="fileAdded"
                    ></vue-dropzone>
            </div>
        </v-flex> 
    </v-layout>
</template>
<script>
    
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import attCorrectionsApi from '@/api/attendancecorrection'
import pageKeys from '@/common/pagekeys'

export default {
    name: 'upload-attachment',
    components: {
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            loading: false,   
            img: null,   
            showUpload: true,      
            dropzoneOptions: {                    
                url: '', //will be populated dynamically
                headers: { 
                    "Authorization": `Bearer ${localStorage.token}`,
                    "page_key": pageKeys.attendance_corrections,
                    "session_id": localStorage.sessionId,
                    "source": "Customer"
                },
                addRemoveLinks: true,
                dictDefaultMessage: "<br><b class='headline'><u>Drag and drop your file or click to browse</u><b><br><br><p class='caption'>Maximum 5MB per file.<br>Accepted files types: pdf and images (*.pdf, *.jpg, *.jpeg, *.png)</p>",
                maxFiles: 1,
                acceptedFiles: 'image/jpeg, image/jpg, image/png, application/pdf',
                maxFilesize: 5,   // 5MB
                init: function() {
                   this.on("error", function(file, message) {
                       const errorEl = file.previewElement.querySelector('.dz-error-message');
                       if (errorEl) {
                           errorEl.addEventListener('click', () => {
                               this.removeFile(file);
                           });
                       }
                   });
                }
            },
            uploading: false,
            error: false,
            errorMessage: '',
            attendanceCorrectionsId: null,
            userId: null
        }
    },
    methods: {
        setData(data){
            this.userId = data.userId
            this.attendanceCorrectionsId = data.attendanceCorrectionsId

            // Update the configuration object directly inside data
            this.dropzoneOptions.url = `${axios.defaults.baseURL}AttendanceCorrections/attachment/upload/${data.userId}`
        },
        fileAdded(file) {
            this.loading = true
        },
        async uploadSuccess(file, response) {
            this.error = false
            try{
                //after successful upload, insert attachment details to db
                var data = {
                    attendanceCorrectionsId: this.attendanceCorrectionsId,
                    fileName: response.fileName,
                    description: ""
                }
                const result = await attCorrectionsApi.saveAttachment(data)
                if (result.status == 200) {
                    this.loading = false
                    this.$refs.myVueDropzone.removeAllFiles()
                    this.$emit('send', null)
                    this.$emit('update:dialogUpload', false)
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading = false
            }
        },
        closeDialog() {
            this.showUpload=true
            this.$emit('update:dialogUpload', false)
        }
    }
}
</script>
<style scoped>
 .upload_bg {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: rgba(0, 0, 0, 0.9)
 }
 .upload_drop {
    height:300px;
    padding:0px 50px 0px 50px;
 }

/* ==========================================================================
   DROPZONE VUE-DEEP STYLING OVERRIDES (CENTERED TEXT ONLY MINIMALIST LOOK)
   ========================================================================== */
::v-deep #dropzone {
    border: 2px dashed rgba(255, 255, 255, 0.3) !important;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.4) !important;
    color: white !important;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 10px;
}
::v-deep #dropzone .dz-preview {
    background: #1e1e1e !important; 
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    border-radius: 8px !important;
    padding: 20px !important;
    width: 280px !important; 
    position: absolute !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.5) !important;
}
::v-deep #dropzone .dz-preview .dz-image {
    border-radius: 6px !important;
    margin: 0 auto 15px auto !important;
    display: block !important;
    width: 120px !important;
    height: 120px !important;
}
::v-deep #dropzone .dz-preview.dz-error .dz-image {
    display: none !important;
}
::v-deep #dropzone .dz-preview .dz-details {
    color: #FFF !important;
    background: transparent !important;
    opacity: 1 !important;
    position: static !important;
    padding: 0 !important;
    text-align: center !important;
    margin-bottom: 12px !important;
}
::v-deep #dropzone .dz-preview .dz-error-message {
    display: none !important; 
}
::v-deep #dropzone .dz-preview.dz-error .dz-error-message {
    position: static !important; 
    opacity: 1 !important;
    display: block !important;
    background: #FF5252 !important;
    color: white !important;
    border-radius: 4px !important;
    padding: 12px 16px !important;
    font-size: 13px !important;
    font-weight: bold !important;
    text-align: center !important;
    margin: 5px 0 0 0 !important;
    width: 100% !important;
    box-sizing: border-box !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease;
}
::v-deep #dropzone .dz-preview.dz-error .dz-error-message:hover {
    background-color: #D32F2F !important;
}
::v-deep #dropzone .dz-preview .dz-error-message:after {
    display: none !important;
}
::v-deep #dropzone .dz-preview .dz-success-mark,
::v-deep #dropzone .dz-preview .dz-error-mark,
::v-deep #dropzone .dz-preview .dz-remove {
    display: none !important;
}
</style>